import { Table } from 'antd'

import { RfqQuote } from '../models'
import { quotesColumns } from './quote-table-columns'

export const RfqQuotes = ({ rfqQuotes }: { rfqQuotes: RfqQuote[] }) => (
  <Table pagination={false} dataSource={sortQuotes(rfqQuotes)} columns={quotesColumns} size="small" />
)

const sortQuotes = (quotes: RfqQuote[]): RfqQuote[] => (quotes?.length ? quotes.sort(byTenor) : [])

const tenors = {
  '1M': 1,
  '2M': 2,
  '3M': 3,
  '4M': 4,
  '5M': 5,
  '6M': 6,
  '7M': 7,
  '8M': 8,
  '9M': 9,
  '10M': 10,
  '11M': 11,
  '12M': 12,
  '1Y': 13,
  '2Y': 14,
  '3Y': 15,
  '4Y': 16,
  '5Y': 17,
}

const byTenor = (firstQuote: RfqQuote, secondQuote: RfqQuote) =>
  tenors[firstQuote.tenor] < tenors[secondQuote.tenor]
    ? -1
    : tenors[firstQuote.tenor] > tenors[secondQuote.tenor]
    ? 1
    : 0
